<div class='wrapperTooltipDefault wrapperTooltipDefault--{{textCenter}}'>
  <!--  [style]='{w:width}|getStyles'-->
  <!--  <span>{{ text }}</span>-->
  <div [innerHTML]='contentInnerHTML'></div>
</div>